var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v-exit",on:{"click":_vm.exit}},[_vm._v("返回")])
}
var staticRenderFns = []

export { render, staticRenderFns }